module.exports = __webpack_public_path__ + "img/title.5df59217.png";